import './src/theme/destyle.css'
import './src/theme/global.css'
import 'keen-slider/keen-slider.min.css'

import { ThemeProvider } from './src/theme'

export const wrapPageElement = ({ element, props }) => {
  return <ThemeProvider {...props}>{element}</ThemeProvider>
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  window.setTimeout(() => window.scrollTo(0, 0))

  return false
}
